import React from 'react';
import { Alert, Box, Heading, PageContent, palette, space, Stack, styled, Text } from 'bumbag';
import format from 'date-fns/format';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _omitBy from 'lodash/omitBy';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'quer... Remove this comment to see the full error message
import queryString from 'query-string';
import Script from 'react-load-script';
import { Loads } from 'react-loads-next';
import { geocodeByAddress } from 'react-places-autocomplete';

import { withRouter } from '@medipass/react-core/router';
import HealthFundDetails from '@medipass/react-core/Transactions/components/consumer/HealthFundDetails';
import ServiceDetails from '@medipass/react-core/Transactions/components/consumer/ServiceDetails';
import ServiceItemDetails from '@medipass/react-core/Transactions/components/consumer/ServiceItemDetails';
import Totals from '@medipass/react-core/Transactions/components/consumer/Totals';
import WithLoadingIndicator from '@medipass/react-core/WithLoadingIndicator';
import {
  ERROR_CODES,
  ERROR_MESSAGES,
  FUTURE_TYPES,
  PAYMENT_FACILITIES,
  TRANSACTION_PAYMENT_OPTIONS,
  TRANSACTION_STATUSES,
} from '@medipass/utils/constants';
import { isHealthPoint, isHICAPS, isMedicare, isOHC, isPatientFunded } from '@medipass/utils/funders';
import env from '@medipass/utils/get-env';
import { parseAddress } from '@medipass/utils/google-addresses';
import { logError } from '@medipass/utils/sentry';
import { mapItemsToClaimItems } from '@medipass/utils/service-items';
import sdk from '@medipass/web-sdk';

import ApproveForm from 'legacy/components/checkout/ApproveForm';
import Footer from 'legacy/components/checkout/Footer/Footer';
import FutureDetails from 'legacy/components/checkout/FutureDetails';
import LayoutPage from 'legacy/components/checkout/layout/Page';
import LocationPermissionsRejected from 'legacy/components/checkout/LocationPermissionsRejected';
import LocationPermissionsRequested from 'legacy/components/checkout/LocationPermissionsRequested';
import PaymentSelection from 'legacy/components/checkout/PaymentSelection';
import WithRequestHealthFund from 'legacy/components/checkout/WithRequestHealthFund';
import WithAuthentication from 'legacy/components/WithAuthentication';
import WithRequestLocationPermissions from 'legacy/components/WithRequestLocationPermissions';
import postMessage from 'legacy/utils/post-message';
import { getKeyFromQueryParams } from 'legacy/utils/router';

import { APPROVE_TYPES } from '../../constants';
import { EXPIRED_CHECKOUT_URL } from '../../constants';

const ERROR__ACCOUNT_DOES_NOT_MATCH = { code: 'accountDoesNotMatch' };
const FUTURE_LABELS = {
  [FUTURE_TYPES.HOLD]: 'Payment hold',
  [FUTURE_TYPES.INSTALMENT_PLAN]: 'Instalment plan',
};

const ERROR_CODE_PAYMENT_GATEWAY = 13022;

const getReturnUrl = (selfCheckoutSession: any, event: 'success' | 'failure' | 'cancel' | 'returnToCart') => {
  const returnUrls = _get(selfCheckoutSession, 'callbackUrls') || _get(selfCheckoutSession, 'returnUrls') || [];
  // @ts-expect-error TS(7006): Parameter 'url' implicitly has an 'any' type.
  const returnUrl = returnUrls.find(url => url.event === event) || {};
  return returnUrl.url;
};

const getPaymentMethodType = (paymentProvider: string) => {
  const paymentProviderToMethodType: { [key: string]: string } = {
    'payment-card': 'creditCard',
    'google-pay': 'googlePay',
    'apple-pay': 'applePay',
  };

  return paymentProviderToMethodType[paymentProvider] || 'creditCard';
};

const Wrapper = styled(Box)`
  & > div:nth-child(even) {
    background-color: ${palette('white600')};
  }
`;

const PaymentRequestHeading = styled(Heading)`
  font-size: 20px !important;
  line-height: 32px !important;
  font-weight: normal !important;
  margin-bottom: ${space(2, 'major')};
  text-align: center;
`;

type Props = {
  history: Function;
};
type State = {
  approveType: string;
  alwaysSavePatientPaymentMethod: boolean;
  errorMessage?: string;
  isCreatingNewPaymentMethod: boolean;
  isAboveLimit?: boolean;
  isPatientFunded?: boolean;
  isPayInPersonEnabled?: boolean;
  funderCode?: string;
  funder: any;
  paymentMethods: any;
  paymentOption: string;
  selectedPaymentMethod: any;
  selfCheckoutSession: any;
  skipHealthFund: boolean;
  transaction?: any;
  type: string;
  paymentFacility: string;
  isEditingHealthFund: boolean;
};

class CheckoutPage extends React.Component<Props, State> {
  addPaymentCardForm: any = React.createRef();

  state: any = {
    approveType: APPROVE_TYPES.CLAIM_AND_PAYMENT,
    alwaysSavePatientPaymentMethod: getKeyFromQueryParams('alwaysSavePatientPaymentMethod'),
    errorMessage: null,
    errorCode: getKeyFromQueryParams('errorCode'),
    isCreatingNewPaymentMethod: false,
    isAboveLimit: getKeyFromQueryParams('isAboveLimit'),
    isEditingHealthFund: false,
    isPatientFunded: getKeyFromQueryParams('isPatientFunded'),
    isPayInPersonEnabled: getKeyFromQueryParams('isPayInPersonEnabled'),
    funderCode: getKeyFromQueryParams('funder'),
    funder: undefined,
    paymentMethods: [],
    paymentOption: TRANSACTION_PAYMENT_OPTIONS.PAYMENT_CARD,
    selectedPaymentMethod: undefined,
    selfCheckoutSession: {},
    paymentFacility: PAYMENT_FACILITIES.HICAPS_GO,
    skipHealthFund: false,
    transaction: {},
    type: 'transaction',
  };

  // @ts-expect-error TS(7006): Parameter 'prevProps' implicitly has an 'any' type... Remove this comment to see the full error message
  componentDidUpdate(prevProps, prevState) {
    const { funderCode, isPatientFunded: _isPatientFunded, transaction } = this.state;
    if (transaction !== prevState.transaction && transaction) {
      const temp_v3 = transaction._schemaVersion === '3';
      const isPatientRecord = Boolean(_get(transaction, 'patient._id'));
      if (isPatientRecord) {
        if (
          _get(transaction, 'approved') ||
          isPatientFunded(funderCode) ||
          _isPatientFunded ||
          (temp_v3 && isMedicare(funderCode))
        ) {
          this.setState({ approveType: APPROVE_TYPES.PAYMENT_ONLY }); // eslint-disable-line
        }
      }
    }
  }

  /* ====== START: LOAD RESOURCES ====== */

  loadInitialResources = async () => {
    const { isPatientFunded: _isPatientFunded, funderCode } = this.state;
    let transaction = {};
    let selfCheckoutSession = await sdk.selfCheckoutSessions.getMySelfCheckoutSession();

    const funders = await sdk.funders.getFunders({ requestConfig: { tokenType: 'session' } });
    const funder = funders.find(funder => funder.code === funderCode);
    this.setState({
      funder,
      paymentFacility: selfCheckoutSession.paymentFacility,
      paymentOption:
        selfCheckoutSession.paymentFacility === 'none'
          ? TRANSACTION_PAYMENT_OPTIONS.PAY_IN_PERSON
          : TRANSACTION_PAYMENT_OPTIONS.PAYMENT_CARD,
    });

    // If existing account, then fetch account/member resources and update self checkout session.
    if (sdk.hasValidSession('account')) {
      selfCheckoutSession = await this.loadAccountResources(selfCheckoutSession, { defaultFunder: funder });
    }

    if (selfCheckoutSession.paymentFacility === PAYMENT_FACILITIES.MEDIPASS_PAYMENTS) {
      let paymentMethods = await sdk.selfCheckoutSessions.getPaymentMethods();
      paymentMethods = paymentMethods.items;
      this.setState({
        paymentMethods: paymentMethods,
        selectedPaymentMethod: paymentMethods[0],
        isCreatingNewPaymentMethod: paymentMethods?.length === 0,
      });
    }

    // If a memberless checkout, and an accountId exists in the checkout session, then throw an error.
    const isAccountless = !_get(sdk, 'account._id');
    if (selfCheckoutSession.accountId && isAccountless) {
      throw ERROR__ACCOUNT_DOES_NOT_MATCH;
    }

    let type;
    if (selfCheckoutSession.futureId) {
      const future = await sdk.futures.getFuture(selfCheckoutSession.futureId, {
        requestConfig: { tokenType: 'session' },
      });
      if (future.futureType === FUTURE_TYPES.HOLD) {
        transaction = { ...transaction, ...future, amountBalanceString: future.hold.amountString };
      }
      if (future.futureType === FUTURE_TYPES.INSTALMENT_PLAN) {
        transaction = {
          // @ts-expect-error
          _transactionId: transaction._id,
          ...transaction,
          ...future,
          amountBalanceString: `$${(future.instalmentPlan.amount / 100).toFixed(2)}`,
        };
      }
      type = 'future';
    } else {
      if (
        _isPatientFunded ||
        isPatientFunded(funderCode) ||
        isMedicare(funderCode) ||
        selfCheckoutSession.invoiceCreated ||
        !funderCode
      ) {
        transaction = await sdk.selfCheckoutSessions.getMySelfCheckoutSessionTransaction(selfCheckoutSession._id, {
          tokenType: 'session',
        });
        if (selfCheckoutSession.eCommerceAccountId) {
          const claimId = _get(transaction, 'claims[0]._id');
          const claimStatus = _get(transaction, 'claims[0].status');
          const healthFundAccount = _get(transaction, 'claims[0].healthFundAccount');
          if (claimStatus === TRANSACTION_STATUSES.NEW && healthFundAccount) {
            try {
              transaction = await sdk.transactions.submitClaim(
                // @ts-expect-error
                transaction._id,
                claimId,
                {},
                {
                  requestConfig: { tokenType: 'session' },
                },
              );
            } catch (err) {
              // For Specsavers patients with unsupported health fund account, this will fail. We want to ignore and redirect them back to hfa entry screen
              if (!_get(transaction, 'claims[0].hicaps.isViaHealthPoint')) {
                const failureReturnUrl = getReturnUrl(selfCheckoutSession, 'failure');
                logError(err);
                if (failureReturnUrl) {
                  this.pushToFailurePage({ err, returnUrl: failureReturnUrl, selfCheckoutSession });
                  return;
                }
                throw err;
              }
            }
          }
        }
        this.setState({
          funderCode: _get(transaction, 'claims[0].funder.code'),
          funder: _get(transaction, 'claims[0].funder'),
          isPatientFunded: _get(transaction, 'claims[0].isPatientFunded', false),
        });
      } else {
        if (!_isEmpty(selfCheckoutSession.member) && _get(selfCheckoutSession, 'healthFundAccount.membershipNumber')) {
          transaction = await sdk.selfCheckoutSessions.createMyInvoice();
        }
      }
      type = 'transaction';
    }

    this.setState({ selfCheckoutSession, transaction, type });
  };

  loadAccountResources = async (selfCheckoutSession: any, { defaultFunder }: any = {}) => {
    const { funderCode } = this.state;
    const funder = defaultFunder || this.state.funder;

    if (!sdk.account && selfCheckoutSession.accountId) {
      const account = await sdk.accounts.getAccount(selfCheckoutSession.accountId);
      sdk.setAccount(account);
    }

    // If the accountId of the logged in user does not match the self checkout session's accountId, throw an error.
    const doesNotMatchAuthedAccountId = _get(sdk, 'account._id') !== selfCheckoutSession.accountId;
    if (selfCheckoutSession.accountId && doesNotMatchAuthedAccountId) {
      throw ERROR__ACCOUNT_DOES_NOT_MATCH;
    }

    const paymentMethods: Record<string, any> = await sdk.payments.getAccountPaymentMethods(_get(sdk, 'account._id'));
    this.setState({ paymentMethods });

    let updateRequestBody = {};
    if (!_get(selfCheckoutSession, 'member._id') && _get(sdk, 'member._id')) {
      updateRequestBody = { ...updateRequestBody, member: { _id: _get(sdk, 'member._id') } };
    }

    if (
      (isHICAPS(funderCode) || isOHC(funderCode) || isHealthPoint(funderCode)) &&
      !_get(selfCheckoutSession, 'healthFundAccount._id')
    ) {
      const healthFundAccounts = await sdk.healthFundAccounts.getMembersHealthFundAccounts(
        _get(selfCheckoutSession, 'member._id') || _get(sdk, 'member._id'),
        { funderId: funder._id },
      );
      const healthFundAccountId = _get(healthFundAccounts, 'items[0]._id');
      if (healthFundAccountId) {
        updateRequestBody = {
          ...updateRequestBody,
          healthFundAccount: { _id: healthFundAccountId },
        };
      }
    }
    if (!_get(selfCheckoutSession, 'paymentMethod._id') && _get(paymentMethods, 'length', 0) > 0) {
      updateRequestBody = { ...updateRequestBody, paymentMethod: { _id: paymentMethods[0]._id } };
    }

    if (updateRequestBody) {
      selfCheckoutSession = await sdk.selfCheckoutSessions.updateMySelfCheckoutSession(updateRequestBody);
    }

    return selfCheckoutSession;
  };

  /* ====== END: LOAD RESOURCES ====== */

  /* ====== START: REQUEST HEALTH FUND ====== */

  handleHealthFundLoginSuccess = async () => {
    let { selfCheckoutSession } = this.state;
    selfCheckoutSession = await this.loadAccountResources(selfCheckoutSession);
    this.setState({ selfCheckoutSession });
  };

  handleSkipHealthFund = async () => {
    let transaction = this.state.transaction;

    const temp_v3 = transaction._schemaVersion === '3';

    if (!temp_v3) {
      transaction = await sdk.selfCheckoutSessions.createMyInvoice();
    }

    // Cancel claim (if exist)
    if (transaction.claims[0]?._id) {
      try {
        // @ts-expect-error TS(2345): Argument of type 'undefined' is not assignable to ... Remove this comment to see the full error message
        transaction = await sdk.transactions.cancelClaim(transaction._id, transaction.claims[0]?._id, undefined, {
          requestConfig: { tokenType: 'session' },
        });
      } catch (err) {
        logError(err);
      }
    }

    this.setState({
      approveType: APPROVE_TYPES.PAYMENT_ONLY,
      isEditingHealthFund: false,
      skipHealthFund: true,
      transaction,
    });
  };

  handleSubmitHealthFund = async (
    { healthFundAccount, member }: { healthFundAccount: any; member: any },
    { position }: { position: any },
  ) => {
    let selfCheckoutSession = this.state.selfCheckoutSession;

    const isUnsupported = _get(healthFundAccount, 'healthFund.isUnsupported');
    if (isUnsupported) {
      await this.handleSkipHealthFund();
      return;
    }

    selfCheckoutSession = await sdk.selfCheckoutSessions.updateMySelfCheckoutSession({
      healthFundAccount,
      member,
    });

    // If an existing member, add the health fund to their account.
    if (sdk.hasValidSession('account')) {
      try {
        await sdk.healthFundAccounts.createMembersHealthFundAccount(_get(sdk, 'member._id'), healthFundAccount);
      } catch (err) {}
    }

    let transaction = this.state.transaction;
    const transactionId = transaction._id;
    const claimId = _get(transaction, 'claims[0]._id');
    const temp_v3 = transaction._schemaVersion === '3';
    try {
      if (temp_v3) {
        // @ts-expect-error TS(2345): Argument of type 'undefined' is not assignable to ... Remove this comment to see the full error message
        transaction = await sdk.transactions.cancelClaim(transactionId, claimId, undefined, {
          requestConfig: { tokenType: 'session' },
        });
        transaction = await sdk.transactions.updateClaim(
          transactionId,
          claimId,
          { healthFundAccount },
          {
            requestConfig: { tokenType: 'session' },
          },
        );

        const submitsRequestBody: any = {};
        if (position && position.coords) {
          submitsRequestBody.lnglat = [position.coords.longitude, position.coords.latitude];
        }

        transaction = await sdk.transactions.submitClaim(transactionId, claimId, submitsRequestBody, {
          requestConfig: { tokenType: 'session' },
        });
      } else {
        transaction = await sdk.selfCheckoutSessions.createMyInvoice();
      }
    } catch (err) {
      const failureReturnUrl = getReturnUrl(selfCheckoutSession, 'failure');
      logError(err);
      if (failureReturnUrl) {
        this.pushToFailurePage({ err, returnUrl: failureReturnUrl, selfCheckoutSession });
        return;
      }
      throw err;
    }

    this.setState({ isEditingHealthFund: false, selfCheckoutSession, transaction });
  };

  /* ====== END: REQUEST HEALTH FUND ====== */

  /* ====== START: MISC ====== */

  handleChangePaymentMethod = async (paymentMethod: any) => {
    const { paymentFacility } = this.state;
    this.setState({ isCreatingNewPaymentMethod: _isEmpty(paymentMethod) });
    if (paymentFacility === PAYMENT_FACILITIES.HICAPS_GO) {
      const selfCheckoutSession = await sdk.selfCheckoutSessions.updateMySelfCheckoutSession({
        paymentMethod,
      });
      this.setState({ selfCheckoutSession });
    } else {
      this.setState({ selectedPaymentMethod: paymentMethod });
    }
  };

  handleChangePaymentOption =
    // @ts-expect-error TS(7031): Binding element 'setFieldValue' implicitly has an ... Remove this comment to see the full error message


      ({ setFieldValue }) =>
      // @ts-expect-error TS(7006): Parameter 'paymentOption' implicitly has an 'any' ... Remove this comment to see the full error message
      paymentOption => {
        setFieldValue('cardNumber', '');
        setFieldValue('expiry', '');
        setFieldValue('cvc', '');
        this.setState({ paymentOption });
      };

  handleLoadGatewayError = () => {
    logError({ message: 'HPF script failed to load' });
    this.setState({ errorMessage: ERROR_MESSAGES.PAYMENT_GATEWAY_ERROR });
  };

  handleEditHealthFund = () => {
    this.setState({ isEditingHealthFund: true });
  };

  handleCancelEditHealthFund = () => {
    this.setState({ isEditingHealthFund: false });
  };

  // Some PMS partners can choose to 'pop up' our checkout experience. In this case,
  // we use postMessage to notify partners of sucecssful, cancelled or failed events.
  getShouldPostMessage = () => {
    const { selfCheckoutSession } = this.state;
    const isPopUpMode = selfCheckoutSession?.callbackUrls?.length === 0;
    return isPopUpMode && selfCheckoutSession?.callbackOrigin;
  };

  handleReject = async () => {
    const { history } = this.props;
    const { approveType, selfCheckoutSession, transaction } = this.state;
    const temp_v3 = transaction._schemaVersion === '3';
    const returnUrl = getReturnUrl(selfCheckoutSession, 'cancel');
    if (selfCheckoutSession.futureId) {
      await sdk.selfCheckoutSessions.cancelSession();
    } else {
      if (temp_v3) {
        await sdk.selfCheckoutSessions.cancelSession();
      } else {
        await sdk.selfCheckoutSessions.cancel();
      }
    }

    if (this.getShouldPostMessage()) {
      postMessage({
        data: { event: 'cancel', transactionId: transaction?._id },
        origin: selfCheckoutSession?.callbackOrigin,
      });
    }
    // @ts-expect-error
    history.push(`/checkout/rejected/?${queryString.stringify(_omitBy({ approveType, returnUrl }, _isNil))}`);
  };

  /* ====== END: MISC ====== */

  /* ====== START: APPROVE PAYMENT ====== */

  addPaymentMethod = async (updateSelfCheckoutSessionBody: any, { data }: any) => {
    const { history } = this.props;
    const { approveType, selfCheckoutSession, paymentFacility, transaction } = this.state;
    const isExistingAccount = selfCheckoutSession.accountId;

    try {
      const { source, nonce } = await sdk.payments.getNonce({
        amount: transaction.amountBalanceString,
        cardNumber: data.cardNumber,
        expiry: data.expiry,
        cvc: data.cvc,
        paymentProvider: data.paymentProvider,
        isSelfCheckoutSession: true,
      });
      if (paymentFacility === PAYMENT_FACILITIES.HICAPS_GO) {
        if (isExistingAccount) {
          // If existing member, create a new payment method for account, then update self checkout session payment method.
          const paymentMethod = await sdk.payments.createAccountPaymentMethod(
            selfCheckoutSession.accountId,
            nonce,
            source,
          );
          updateSelfCheckoutSessionBody = {
            ...updateSelfCheckoutSessionBody,
            paymentMethod: { _id: paymentMethod._id },
          };
        } else {
          // If new member, create payment method for self checkout session
          await sdk.selfCheckoutSessions.createPaymentMethod(nonce, source);
        }
      }
      return { updateSelfCheckoutSessionBody, nonce, source };
    } catch (err) {
      logError(err);
      const failureReturnUrl = getReturnUrl(selfCheckoutSession, 'failure');
      if (failureReturnUrl) {
        // @ts-expect-error
        history.push(
          `/checkout/failed/?${queryString.stringify(
            _omitBy(
              {
                approveType,
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                error: JSON.stringify(_get(err, 'data', { message: err.message })),
                returnUrl: failureReturnUrl,
              },
              _isNil,
            ),
          )}`,
        );
        return {};
      }
      throw err;
    }
  };

  handleRemovePaymentMethod = async () => {
    let paymentMethods = await sdk.selfCheckoutSessions.getPaymentMethods();
    paymentMethods = paymentMethods.items;
    this.setState({
      paymentMethods: paymentMethods,
      selectedPaymentMethod: paymentMethods?.[0],
      isCreatingNewPaymentMethod: paymentMethods?.length === 0,
    });
  };

  addMember = (updateSelfCheckoutSessionBody: any, { data }: { data: any }) => {
    const { transaction } = this.state;
    const dobArray = data.dob.split('/');
    const dobString = `${dobArray[2]}-${dobArray[1]}-${dobArray[0]}`;
    const temp_v3 = transaction._schemaVersion === '3';
    return {
      ...updateSelfCheckoutSessionBody,
      [temp_v3 ? 'patient' : 'member']: {
        firstName: data.firstName,
        lastName: data.lastName,
        dobString,
        mobile: data.mobile,
        email: data.email,
      },
    };
  };

  handleApprove = async (data: any, { position }: { position: any }) => {
    const {
      approveType,
      errorCode,
      funderCode,
      paymentMethods,
      paymentOption,
      selectedPaymentMethod,
      selfCheckoutSession: _selfCheckoutSession,
      transaction,
      type,
    } = this.state;

    let selfCheckoutSession = _selfCheckoutSession;
    const temp_v2 = transaction._schemaVersion === '2';
    const isExistingAccount = selfCheckoutSession.accountId;
    const failureReturnUrl = getReturnUrl(selfCheckoutSession, 'failure');
    const successReturnUrl = getReturnUrl(selfCheckoutSession, 'success');
    let updateSelfCheckoutSessionBody: any = {};

    // If payment card details exist, add payment method to the self checkout session.
    let paymentMethodData;
    if ((data.cardNumber && data.expiry && data.cvc) || data.paymentProvider) {
      paymentMethodData = await this.addPaymentMethod(updateSelfCheckoutSessionBody, { data });
      updateSelfCheckoutSessionBody = paymentMethodData.updateSelfCheckoutSessionBody;
    }

    // If user has not registered with Tyro Health and wants to create a new Tyro Health account, add the member to the self checkout session.
    if (!isExistingAccount && data.isCreatingAccount) {
      updateSelfCheckoutSessionBody = this.addMember(updateSelfCheckoutSessionBody, { data });
    }

    try {
      selfCheckoutSession = await sdk.selfCheckoutSessions.updateMySelfCheckoutSession(updateSelfCheckoutSessionBody);
      if (!isExistingAccount && data.isCreatingAccount) {
        await sdk.selfCheckoutSessions.rememberMe();
        selfCheckoutSession = await sdk.selfCheckoutSessions.getMySelfCheckoutSession();
        this.setState({ selfCheckoutSession });
      }

      let approveRequestBody: any = {};
      if (position && position.coords) {
        approveRequestBody.lnglat = [position.coords.longitude, position.coords.latitude];
      }

      if (data && _get(data, 'location.value')) {
        const results = await geocodeByAddress(_get(data, 'location.value'));
        const addressComponents = parseAddress(results[0].address_components);
        approveRequestBody = { ...approveRequestBody, postalAddress: _omitBy(addressComponents, _isEmpty) };
      }

      if (data.bankAccountCheckBox === 'true') {
        approveRequestBody = {
          ...approveRequestBody,
          bankAccount: {
            accountName: data.bankAccountName,
            accountNumber: data.bankAccountNumber,
            bsb: data.bankBSB,
          },
        };
      }

      if (temp_v2) {
        approveRequestBody = {
          ...approveRequestBody,
          skipPayment:
            paymentOption === TRANSACTION_PAYMENT_OPTIONS.PAY_IN_PERSON ||
            (!data.cardNumber && paymentMethods.length === 0),
          skipClaim: approveType === APPROVE_TYPES.PAYMENT_ONLY,
        };
        await sdk.selfCheckoutSessions.approve(approveRequestBody);
      } else {
        const claimId = _get(transaction, 'claims[0]._id');
        const claimStatus = _get(transaction, 'claims[0].status');
        if (isMedicare(funderCode) && claimStatus === TRANSACTION_STATUSES.NEW) {
          await sdk.transactions.submitClaim(
            transaction._id,
            claimId,
            {},
            {
              requestConfig: { tokenType: 'session' },
            },
          );
        }
        if (approveType === APPROVE_TYPES.CLAIM_AND_PAYMENT) {
          const claimStatus = _get(transaction, 'claims[0].status');
          if (
            claimId &&
            claimStatus === TRANSACTION_STATUSES.ACCEPTED &&
            (!selfCheckoutSession.eCommerceAccountId || _get(transaction, 'amountBalance', 0) === 0)
          ) {
            await sdk.transactions.approveClaim(transaction._id, claimId, approveRequestBody, {
              requestConfig: { tokenType: 'session' },
            });
          }
          if (data.rememberCardDetails && claimId) {
            await sdk.transactions.saveClaimDetails(transaction._id, claimId, {
              requestConfig: { tokenType: 'session' },
            });
          }
        }
        if (
          approveType === APPROVE_TYPES.PAYMENT_ONLY ||
          approveType === APPROVE_TYPES.CLAIM_AND_PAYMENT ||
          data.cardNumber ||
          data.paymentProvider ||
          data.nonce ||
          paymentMethods.length > 0
        ) {
          let requestBody: any = {};
          if (paymentOption === TRANSACTION_PAYMENT_OPTIONS.PAYMENT_CARD) {
            requestBody = {
              paymentMethodId: _get(selfCheckoutSession, 'paymentMethod._id') || _get(selectedPaymentMethod, '_id'),
            };
          }
          if (paymentOption === TRANSACTION_PAYMENT_OPTIONS.PAY_IN_PERSON) {
            requestBody = {
              payInPerson: true,
            };
          }

          const nonce = _get(data, 'nonce') || _get(paymentMethodData, 'nonce');
          const source = _get(paymentMethodData, 'source');
          if (nonce && (!requestBody.paymentMethodId || data.cardNumber)) {
            requestBody = {
              paymentToken: {
                nonce,
                source,
                saveOnSuccess: !isExistingAccount && !data.paymentProvider && data.rememberCardDetails,
                methodType: getPaymentMethodType(data?.paymentProvider),
              },
            };
          }

          if (!nonce || _isEmpty(requestBody)) {
            logError(new Error('No nonce found'), {
              name: 'Invalid Payment Request',
              data: {
                paymentOption,
              },
            });
          }

          if (type === 'transaction' && _get(transaction, 'amountBalance', 0) > 0) {
            await sdk.transactions.pay(transaction._id, requestBody, { requestConfig: { tokenType: 'session' } });
          }
          if (type === 'future') {
            if (errorCode === ERROR_CODES.CARD_FAILED) {
              await sdk.futures.update(selfCheckoutSession.futureId, requestBody, {
                requestConfig: { tokenType: 'session' },
              });
            } else {
              await sdk.futures.submit(selfCheckoutSession.futureId, requestBody, {
                requestConfig: { tokenType: 'session' },
              });
            }
          }
        }
      }

      if (data.receiptEmail && _get(transaction, 'instalmentPlan.transactionId')) {
        try {
          await sdk.transactions.sendReceipt(
            _get(transaction, 'instalmentPlan.transactionId'),
            { email: data.receiptEmail },
            { requestConfig: { tokenType: 'session' } },
          );
        } catch (err) {}
      }

      this.pushToSuccessPage({
        isExistingAccount,
        returnUrl: successReturnUrl,
        selfCheckoutSession,
      });
    } catch (err) {
      logError(err);
      // For some error codes, we don't want to redirect to the failed screen.
      if (
        _get(err, 'data.errorCode') &&
        [
          ERROR_CODES.PAYMENT_PROVIDER_PARAMETERS_INVALID,
          ERROR_CODES.USERNAME_ALREADY_EXISTS,
          ERROR_CODE_PAYMENT_GATEWAY,
        ].includes(
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          err.data.errorCode,
        )
      ) {
        throw err;
      }
      if (failureReturnUrl) {
        this.pushToFailurePage({ err, returnUrl: failureReturnUrl, selfCheckoutSession });
        return;
      }
      throw err;
    }
  };

  pushToSuccessPage = ({
    isExistingAccount,
    returnUrl,
    selfCheckoutSession,
  }: {
    isExistingAccount?: boolean;
    returnUrl?: string;
    selfCheckoutSession?: any;
  }) => {
    const { history } = this.props;
    const { approveType, transaction, type } = this.state;

    let amount = transaction.amountBalanceString;
    if (transaction.futureType === FUTURE_TYPES.INSTALMENT_PLAN) {
      amount = _get(transaction, 'instalmentPlan.paymentSchedule[0].amountString');
    }

    let firstPaymentDate;
    if (transaction.futureType === FUTURE_TYPES.INSTALMENT_PLAN) {
      const firstSchedule = _get(transaction, 'instalmentPlan.paymentSchedule[0]');
      if (!firstSchedule.paymentId) {
        firstPaymentDate = _get(transaction, 'instalmentPlan.paymentSchedule[0].chargeDateString');
      }
    }

    if (this.getShouldPostMessage()) {
      postMessage({
        data: { event: 'success', transactionId: transaction?._id, receiptAutoSent: selfCheckoutSession?.sendReceipt },
        origin: selfCheckoutSession?.callbackOrigin,
      });
    }

    // If member exists and the checkout session does not have a return url,
    // we want to direct them to their account.
    if (isExistingAccount && !returnUrl) {
      // @ts-expect-error
      history.push(`/account/transactions/?${queryString.stringify({ approveType })}`);
      window.scrollTo(0, 0);
    } else {
      if (selfCheckoutSession.eCommerceAccountId && returnUrl) {
        window.location.href = returnUrl;
      } else {
        // @ts-expect-error
        history.push(
          `/checkout/success/?${queryString.stringify(
            _omitBy(
              {
                amount,
                approveType,
                firstPaymentDate,
                returnUrl,
                transactionId: transaction._id,
                futureType: transaction.futureType,
                type,
                autoSendReceipt: selfCheckoutSession?.sendReceipt,
              },
              _isNil,
            ),
          )}`,
        );
      }
    }
  };

  pushToFailurePage = ({
    err,
    returnUrl,
    selfCheckoutSession,
  }: {
    err: any; // eslint-disable-line react/no-unused-prop-types
    returnUrl?: string; // eslint-disable-line react/no-unused-prop-types
    selfCheckoutSession?: any; // eslint-disable-line react/no-unused-prop-types
  }) => {
    const { history } = this.props;
    const { approveType, transaction } = this.state;

    if (this.getShouldPostMessage()) {
      postMessage({
        data: { event: 'failure', transactionId: transaction?._id },
        origin: selfCheckoutSession?.callbackOrigin,
      });
    }
    // @ts-expect-error
    history.push(
      `/checkout/failed/?${queryString.stringify(
        _omitBy({ approveType, error: JSON.stringify(_get(err, 'data', { message: err.message })), returnUrl }, _isNil),
      )}`,
    );
  };

  // @ts-expect-error TS(7006): Parameter 'err' implicitly has an 'any' type.
  handleApplePayError = err => this.pushToFailurePage({ err });

  /* ====== END: APPROVE PAYMENT ====== */

  render = () => {
    const {
      approveType,
      alwaysSavePatientPaymentMethod,
      errorCode,
      isCreatingNewPaymentMethod,
      isAboveLimit,
      isPatientFunded: _isPatientFunded,
      isEditingHealthFund,
      isPayInPersonEnabled,
      funderCode,
      funder,
      paymentMethods,
      selectedPaymentMethod,
      selfCheckoutSession,
      paymentFacility,
      paymentOption,
      skipHealthFund,
      transaction,
    } = this.state;
    const claimItems = _get(transaction, 'claims[0].claimItems', []);
    const allItems = mapItemsToClaimItems(transaction);
    const isFuture = Boolean(selfCheckoutSession.futureId);
    const isVirtualTerminal = _get(transaction, 'items[0].fullName') === 'Card payment';
    const requiresPayment = isFuture ? true : _get(transaction, 'amountBalance', 0) > 0;
    const claimStatus = _get(transaction, 'claims[0].status');
    const isHealthFundEnabled =
      isEditingHealthFund ||
      (approveType !== APPROVE_TYPES.PAYMENT_ONLY &&
        !skipHealthFund &&
        (isHICAPS(funderCode) || isOHC(funderCode) || isHealthPoint(funderCode)) &&
        !_isPatientFunded &&
        (!_get(selfCheckoutSession, 'healthFundAccount.membershipNumber') || claimStatus === TRANSACTION_STATUSES.NEW));
    const isRequestLocationEnabled =
      approveType !== APPROVE_TYPES.PAYMENT_ONLY &&
      (isHICAPS(funderCode) || isOHC(funderCode) || isHealthPoint(funderCode)) &&
      !_isPatientFunded &&
      !selfCheckoutSession.eCommerceAccountId;
    const healthFundAccount = selfCheckoutSession.healthFundAccount || _get(transaction, 'claims[0].healthFundAccount');
    const temp_v3 = transaction._schemaVersion === '3';

    return (
      <WithAuthentication
        expiredTokenRedirectUrl={EXPIRED_CHECKOUT_URL}
        isSelfCheckoutSession
        requiresValidAccountToken={false}
        requiresValidSessionToken
      >
        <LayoutPage title="Checkout">
          {/* @ts-ignore */}
          <Loads fn={this.loadInitialResources}>
            {({ error, isPending, isResolved, isRejected }) => (
              <React.Fragment>
                {isPending && (
                  <PageContent breakpoint="checkout">
                    <WithLoadingIndicator isActive />
                  </PageContent>
                )}
                {isResolved && (
                  <WithRequestLocationPermissions
                    enabled={isRequestLocationEnabled}
                    locationPermissionsRequestedRenderer={() => (
                      <LocationPermissionsRequested amountBenefit={transaction.amountBenefitString} />
                    )}
                    onSkipHealthFund={this.handleSkipHealthFund}
                    locationPermissionsRejectedRenderer={({ error }) => <LocationPermissionsRejected error={error} />}
                    wrapper={children => (
                      <PageContent breakpoint="checkout">
                        {isFuture ? (
                          <PaymentRequestHeading>
                            {/* @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message */}
                            {FUTURE_LABELS[_get(transaction, 'futureType')]} request from{' '}
                            {_get(transaction, 'practice.displayName')}
                          </PaymentRequestHeading>
                        ) : (
                          <PaymentRequestHeading>
                            Payment request from {_get(transaction, 'practice.displayName')}
                          </PaymentRequestHeading>
                        )}
                        {children}
                      </PageContent>
                    )}
                  >
                    {({ position }) => (
                      <WithRequestHealthFund
                        allowSkipHealthFund
                        enabled={isHealthFundEnabled}
                        isHealthFundUpdatesDisabled={transaction?.claims?.[0]?.isHealthFundUpdatesDisabled}
                        returnToCartUrl={getReturnUrl(selfCheckoutSession, 'returnToCart')}
                        firstName={
                          _get(selfCheckoutSession, 'member.firstName') ||
                          _get(selfCheckoutSession, 'patient.firstName', '')
                        }
                        lastName={
                          _get(selfCheckoutSession, 'member.lastName') ||
                          _get(selfCheckoutSession, 'patient.lastName', '')
                        }
                        initialDob={
                          _get(selfCheckoutSession, 'member.dobString') ||
                          _get(selfCheckoutSession, 'patient.dobString')
                            ? format(
                                _get(selfCheckoutSession, 'member.dobString') ||
                                  _get(selfCheckoutSession, 'patient.dobString'),
                                'DD/MM/YYYY',
                              )
                            : ''
                        }
                        funder={funder}
                        initialHealthFundId={
                          _get(transaction, 'claims[0].healthFund._id') ||
                          _get(selfCheckoutSession, 'healthFundAccount.healthFund._id')
                        }
                        initialHealthFundAccount={_get(selfCheckoutSession, 'healthFundAccount')}
                        onClickCancel={this.handleCancelEditHealthFund}
                        onClickReject={this.handleReject}
                        // @ts-expect-error
                        onLoginSuccess={this.handleHealthFundLoginSuccess}
                        onSkipHealthFund={this.handleSkipHealthFund}
                        onSubmitHealthFund={data => this.handleSubmitHealthFund(data, { position })}
                        state={isEditingHealthFund ? 'edit' : 'create'}
                        wrapper={children => <PageContent breakpoint="checkout">{children}</PageContent>}
                      >
                        <Script url={env.HPF_SCRIPT_URL} onError={this.handleLoadGatewayError} />
                        <ApproveForm
                          selectedPaymentMethod={selectedPaymentMethod}
                          paymentOption={paymentOption}
                          enableApplePay={paymentOption === TRANSACTION_PAYMENT_OPTIONS.APPLE_PAY}
                          enableGooglePay={paymentOption === TRANSACTION_PAYMENT_OPTIONS.GOOGLE_PAY}
                          enableReinitialize
                          // @ts-expect-error
                          hasNoPaymentMethods={paymentMethods.length === 0}
                          initialValues={{
                            firstName: _get(selfCheckoutSession, 'member.firstName', ''),
                            lastName: _get(selfCheckoutSession, 'member.lastName', ''),
                            dob: _get(selfCheckoutSession, 'member.dobString')
                              ? format(selfCheckoutSession.member.dobString, 'DD/MM/YYYY')
                              : '',
                            email: _get(selfCheckoutSession, 'member.email', ''),
                            receiptEmail: _get(selfCheckoutSession, 'patient.email', ''),
                            mobile: _get(selfCheckoutSession, 'member.mobile', ''),
                            rememberCardDetails: alwaysSavePatientPaymentMethod ? true : false,
                            isCreatingAccount: false,
                            electronicClaimLodgement: false,
                          }}
                          isCreatingNewPaymentMethod={isCreatingNewPaymentMethod}
                          isExistingAccount={selfCheckoutSession.accountId}
                          onApplePayError={this.handleApplePayError}
                          onClickReject={this.handleReject}
                          onSubmit={data => this.handleApprove(data, { position })}
                          showDeclaration={
                            (isHICAPS(funderCode) || isOHC(funderCode) || isHealthPoint(funderCode)) &&
                            !_isPatientFunded
                          }
                          showElectronicLodgementDeclaration={
                            isMedicare(funderCode) && !transaction?.claims[0]?.isPatientFunded
                          }
                          showReject
                          transaction={transaction}
                          wrapper={children => <Wrapper>{children}</Wrapper>}
                        >
                          {({ setFieldValue, values }) => (
                            <React.Fragment>
                              <PageContent breakpoint="checkout">
                                <Stack spacing="major-2">
                                  {errorCode === ERROR_CODES.CARD_FAILED && (
                                    <Alert hasIcon variant="tint" type="danger" title="Payment failed">
                                      The card used to process your instalment plan has failed. Please enter a valid
                                      payment card below to complete this transaction.
                                    </Alert>
                                  )}
                                  {isFuture ? (
                                    <PaymentRequestHeading>
                                      {/* @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message */}
                                      {FUTURE_LABELS[_get(transaction, 'futureType')]} request from{' '}
                                      {_get(transaction, 'practice.displayName')}
                                    </PaymentRequestHeading>
                                  ) : (
                                    <PaymentRequestHeading>
                                      Payment request from {_get(transaction, 'practice.displayName')}
                                    </PaymentRequestHeading>
                                  )}
                                  <Box textAlign="center">
                                    <Text fontSize="600">{_get(transaction, 'amountBalanceString')}</Text>
                                  </Box>
                                  <ServiceDetails
                                    created={transaction.created}
                                    modality={transaction.modality}
                                    practice={transaction.practice}
                                    staff={transaction.staff}
                                    invoiceReference={transaction.invoiceReference}
                                  />
                                  {isFuture && <FutureDetails transaction={transaction} />}
                                </Stack>
                              </PageContent>

                              {approveType === APPROVE_TYPES.CLAIM_AND_PAYMENT &&
                                claimStatus !== TRANSACTION_STATUSES.REVERSED &&
                                healthFundAccount &&
                                !_isPatientFunded &&
                                !isPatientFunded(funderCode) &&
                                claimItems.length > 0 && (
                                  <PageContent breakpoint="checkout">
                                    <HealthFundDetails
                                      enableEdit={
                                        temp_v3 &&
                                        (isHICAPS(funderCode) || isOHC(funderCode) || isHealthPoint(funderCode))
                                      }
                                      funderCode={funderCode}
                                      healthFundAccount={healthFundAccount}
                                      isSelfCheckoutSession
                                      isFormActive={requiresPayment}
                                      onClickEdit={this.handleEditHealthFund}
                                      transaction={transaction}
                                    />
                                  </PageContent>
                                )}

                              {!isVirtualTerminal && !isFuture && (
                                <PageContent breakpoint="checkout">
                                  <Totals
                                    displayTotalShippingAmount
                                    funderCode={funderCode}
                                    serviceItem={allItems.length === 1 ? allItems[0] : null}
                                    transaction={transaction}
                                  />
                                  {allItems.length > 1 && (
                                    <ServiceItemDetails
                                      funderCode={funderCode}
                                      serviceItems={allItems}
                                      transaction={transaction}
                                    />
                                  )}
                                </PageContent>
                              )}

                              {requiresPayment && (
                                <PageContent breakpoint="checkout">
                                  <PaymentSelection
                                    amount={transaction.amountBalanceString}
                                    alwaysSavePatientPaymentMethod={alwaysSavePatientPaymentMethod}
                                    cardPaymentMethods={
                                      isAboveLimit || errorCode === ERROR_CODES.CARD_FAILED ? [] : paymentMethods
                                    }
                                    funderCode={funderCode}
                                    onChangeCardPaymentMethod={this.handleChangePaymentMethod}
                                    onChangePaymentOption={this.handleChangePaymentOption({ setFieldValue })}
                                    onRemovePaymentMethod={this.handleRemovePaymentMethod}
                                    paymentOption={paymentOption}
                                    selectedCardPaymentMethod={
                                      isAboveLimit || errorCode === ERROR_CODES.CARD_FAILED
                                        ? undefined
                                        : _get(selfCheckoutSession, 'paymentMethod') || selectedPaymentMethod
                                    }
                                    showExternalPaymentProviders={
                                      paymentFacility === PAYMENT_FACILITIES.MEDIPASS_PAYMENTS &&
                                      _get(transaction, 'futureType') !== FUTURE_TYPES.INSTALMENT_PLAN
                                    }
                                    showPayInPerson={Boolean(
                                      isPayInPersonEnabled && !selfCheckoutSession.eCommerceAccountId,
                                    )}
                                    showPaymentCard={paymentFacility !== 'none'}
                                    showRememberCardDetails={
                                      _isEmpty(selectedPaymentMethod) &&
                                      ((!isAboveLimit &&
                                        paymentFacility === PAYMENT_FACILITIES.MEDIPASS_PAYMENTS &&
                                        paymentOption === TRANSACTION_PAYMENT_OPTIONS.PAYMENT_CARD &&
                                        _get(transaction, 'futureType') !== FUTURE_TYPES.INSTALMENT_PLAN &&
                                        _get(selfCheckoutSession, 'patient._id')) ||
                                        (alwaysSavePatientPaymentMethod &&
                                          paymentFacility === PAYMENT_FACILITIES.MEDIPASS_PAYMENTS &&
                                          paymentOption === TRANSACTION_PAYMENT_OPTIONS.PAYMENT_CARD &&
                                          !isAboveLimit))
                                    }
                                    // @ts-expect-error
                                    rememberCardDetails={values?.rememberCardDetails}
                                  />
                                </PageContent>
                              )}
                            </React.Fragment>
                          )}
                        </ApproveForm>
                      </WithRequestHealthFund>
                    )}
                  </WithRequestLocationPermissions>
                )}
              </React.Fragment>
            )}
          </Loads>
        </LayoutPage>
        <Footer />
      </WithAuthentication>
    );
  };
}

export default withRouter(CheckoutPage);
